import { useEffect, useState } from "react";
import { noteForIndex, type InstrumentPlayerProps } from "../playerTypes";

export function SaronPlayer(props: InstrumentPlayerProps) {
  const [dampingState, setDampingState] = useState("open sustain");

  useEffect(() => {
    setDampingState(props.activeNotes.length > 0 ? "open sustain" : "damped");
  }, [props.activeNotes.length]);

  return (
    <div className="instrument-ui saron-ui" data-testid="instrument-player-gamelan_saron">
      <div className="saron-bars" aria-label="Gamelan saron bronze bars" data-control-target="saron-bars">
        {Array.from({ length: 7 }, (_, index) => {
          const noteName = noteForIndex(props.instrument.playableNotes, index);
          return (
            <button
              key={index}
              type="button"
              className="saron-bar"
              data-testid={index === 0 ? "saron-key-0" : undefined}
              aria-label={`Strike saron bronze bar ${index + 1}`}
              onPointerDown={() => {
                setDampingState("open sustain");
                props.onNoteStart({ source: "pointer", noteName, velocity: 0.76, ornament: "open_sustain" });
              }}
              onPointerUp={() => {
                setDampingState("damped");
                props.onNoteEnd(noteName);
              }}
              onKeyDown={(event) => {
                if (!event.repeat && (event.key === "Enter" || event.key === " ")) {
                  setDampingState("open sustain");
                  props.onNoteStart({ source: "button", noteName, velocity: 0.76, ornament: "open_sustain" });
                }
              }}
              onKeyUp={() => {
                setDampingState("damped");
                props.onNoteEnd(noteName);
              }}
            >
              {index + 1}
            </button>
          );
        })}
      </div>
      <div className="instrument-control-strip">
        <select aria-label="Saron tuning approximation selector" defaultValue={props.tuning.id} onChange={(event) => props.onControl("saron_tuning_hint", event.currentTarget.value)}>
          <option value="genericSlendroApprox">Slendro approx</option>
          <option value="genericPelogApprox">Pelog approx</option>
        </select>
        <label className="surface-slider" data-control-target="saron-ombak"><span>Ombak</span><input aria-label="Saron ombak shimmer depth" type="range" min="0" max="1" step="0.01" defaultValue="0.45" onInput={(event) => props.onControl("ombak_depth", Number(event.currentTarget.value))} /></label>
        <span className="control-state-pill" data-testid="saron-damping-status">{dampingState}</span>
      </div>
      <p className="instrument-note">Actual gamelan tuning varies by ensemble; these slendro/pelog controls are approximations.</p>
    </div>
  );
}
